__turbopack_context__.v({
  "navigation": "_8kze2q_navigation",
  "navigation--open": "_8kze2q_navigation--open",
  "navigation__item": "_8kze2q_navigation__item",
  "navigation__link": "_8kze2q_navigation__link",
  "navigation__list": "_8kze2q_navigation__list",
});
